import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import SaleService from "services/saleService";

export const initialState = {
  loading: false,
  reportLoading: false,
  message: "",
  saleDataByCategory: [],
  topProducts: [],
  dashboardStats: {},
  mainDashboardStats: {},
  salesReport: null,
  showMessage: false,
  redirect: "",
};

export const getSalesByCategory = createAsyncThunk(
  "sales/getSalesByCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await SaleService.getSalesByCategory();
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getTopProducts = createAsyncThunk(
  "sales/getTopProducts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await SaleService.getTopProducts();
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getDashboardStats = createAsyncThunk(
  "sales/getDashboardStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await SaleService.getDashboardStats();
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getMainDashboardStats = createAsyncThunk(
  "sales/getMainDashboardStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await SaleService.getMainDashboardStats();
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getSalesReport = createAsyncThunk(
  "sales/getSalesReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await SaleService.getSalesReport(params);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saleSlice = createSlice({
  name: "sale",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSalesByCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.saleDataByCategory = action.payload;
      })
      .addCase(getSalesByCategory.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })
      .addCase(getTopProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTopProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.topProducts = action.payload;
      })
      .addCase(getTopProducts.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })
      .addCase(getDashboardStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardStats = action.payload;
      })
      .addCase(getDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })
      .addCase(getMainDashboardStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMainDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.mainDashboardStats = action.payload;
      })
      .addCase(getMainDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })
      .addCase(getSalesReport.pending, (state) => {
        state.reportLoading = true;
      })
      .addCase(getSalesReport.fulfilled, (state, action) => {
        state.reportLoading = false;
        state.salesReport = action.payload;
      })
      .addCase(getSalesReport.rejected, (state, action) => {
        state.reportLoading = false;
        state.message = action.payload;
        state.showMessage = true;
      });
  },
});

export default saleSlice.reducer;
